
        var result = require("!!../../../../node_modules/css-loader/index.js!./employee-info.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/employee-info/employee-info.component.css
// module id = 2519
// module chunks = 1